import React, { useEffect, useState } from "react";
import axios from "axios";
import toast from "react-hot-toast";
import { useHistory } from "react-router-dom";

import user from "../../static/images/user_default.png";

import "../../static/css/homecompanyres.css";
import useMediaQuery from "../../Hooks/useMediaQuery";
import { parseIsolatedEntityName } from "typescript";

function Carousel({ id, qty }) {
  const [currentPage, setcurrentPage] = useState(2);
  const [totalPages, settotalPages] = useState(3);
  const [items, setitems] = useState([]);
  const [indicators, setindicators] = useState([]);
  const [info, setinfo] = useState([]);
  const isMobile = useMediaQuery("(max-width: 984px)");

  let history = useHistory();

  useEffect(() => {
    // Carouselinner();
    GenerateItems();
  }, []);

  const GenerateItems = async () => {
    let arr = [];
    for (let i = 0; i <= 1; i++) {
      let data = await GetData(i, isMobile ? 1 : 3); //el 3 es la cantidad de item para mostrar en el carrousel
      if (data != undefined) {
        let item = (
          <div
            key={id + "carousel_" + Math.floor(Math.random() * 1000)}
            data-bs-interval="1000000"
            className={i == 0 ? "carousel-item active" : "carousel-item"}
          >
            {data.map((item, idex) => {
              return (
                <div
                  key={idex + "_" + item.aplicanteId}
                  className="card-item d-flex d-xl-inline-flex d-sm-flex "
                >
                  <div
                    className="card-container text-center text-sm-center  "
                    id="carruselcandidato"
                  >
                    <div className="card-logo border-gray">
                      <img
                        loading="lazy"
                        src={item.photo != null ? item.photo : user}
                      ></img>
                    </div>
                    <p className="title">
                      {item.nombre} {item.apellido}
                    </p>
                    <hr></hr>
                    <button
                      className="btn-deg"
                      onClick={() => setLink(item.aplicanteId)}
                    >
                      Ver
                    </button>
                  </div>
                </div>
              );
            })}
          </div>
        );
        arr.push(item);
      }
    }
    // setcurrentPage(3);
    setinfo(arr);
  };

  const GetData = async (page, paginate) => {
    try {
      const data = await axios.get("access/list-applicants?tipo=" + id, {
        params: {
          page: page,
          paginate: paginate,
        },
      });
      return data.data.content;
    } catch (error) {}
  };

  const NextPageNew = async () => {
    if (currentPage > 1) {
      let arr = info;
      let data = await GetData(currentPage, isMobile ? 1 : 3);
      if (data.length > 0) {
        let item = (
          <div
            key={id + "carousel_" + Math.floor(Math.random() * 1000)}
            data-bs-interval="1000000"
            className="carousel-item"
          >
            {data.map((item, idex) => {
              return (
                <div key={idex + "_" + item.aplicanteId} className="card-item ">
                  <div className="card-container">
                    <div className="card-logo border-gray ">
                      <img
                        loading="lazy"
                        src={item.photo != null ? item.photo : user}
                      ></img>
                    </div>
                    <p className="title">
                      {item.nombre} {item.apellido}
                    </p>
                    <hr></hr>
                    <button
                      className="btn-deg"
                      onClick={() => setLink(item.aplicanteId)}
                    >
                      Ver
                    </button>
                  </div>
                </div>
              );
            })}
          </div>
        );
        // setcurrentPage(currentPage + 1);
        arr.push(item);
        setinfo(arr);
      }
    }
  };

  function LoadIndicators(data) {
    let arr = [];

    for (let index = 0; index <= data; index++) {
      let btn = (
        <button
          key={index}
          type="button"
          data-bs-target={"#carousel" + id}
          data-bs-slide-to={"" + index + ""}
          aria-label={"Slide " + (index + 1)}
          className={index == 0 ? "active" : ""}
        ></button>
      );
      arr.push(btn);
    }
    setindicators(arr);
  }

  function setLink(item) {
    let rol = localStorage.getItem("rol");
    let path;
    let state;
    switch (rol) {
      case "applicant":
        path = "/user/Vacante/" + item;
        state = {};
        break;
      case "company":
        history.push({
          pathname: "/company/Candidato/",
          state: { userid: item },
        });
        break;
      case "institute":
        history.push({
          pathname: "/CentroFormacion/Candidato",
          state: { userid: item },
        });
        break;
    }
  }

  return (
    <div
      id={"carousel" + id}
      className="carousel slide"
      data-interval="false"
      style={{ maxHeight: "330px" }}
    >
      {/* <div className="carousel-indicators">{indicators}</div> */}
      <div className="carousel-inner ">{info}</div>
      <button
        className="carousel-control-prev"
        type="button"
        data-bs-target={"#carousel" + id}
        data-bs-slide="prev"
      ></button>
      <button
        className="carousel-control-next"
        type="button"
        data-bs-target={"#carousel" + id}
        data-bs-slide="next"
        onClick={() => {
          setcurrentPage(currentPage + 1);
          NextPageNew();
        }}
      ></button>
    </div>
  );
}

export default Carousel;
